// Minimale Pfad-Navigation ohne Router-Bibliothek.
//
// Firebase Hosting schreibt jeden Pfad auf index.html um, deshalb genügt es,
// window.location.pathname beim Start auszuwerten. Für Wechsel innerhalb der
// App wird history.pushState benutzt und ein eigenes Event ausgelöst — nicht
// popstate, weil index.js darauf im Standalone-Modus bereits eigene Logik
// hängen hat.

export const ADMIN_PATH = '/admin';

const ROUTE_EVENT = 'augenstern:routechange';

function normalizePath(pathname) {
  const trimmed = pathname.toLowerCase().replace(/\/+$/, '');
  return trimmed.length > 0 ? trimmed : '/';
}

// Akzeptiert /admin ebenso wie /Admin oder /admin/.
export function currentRoute() {
  return normalizePath(window.location.pathname) === ADMIN_PATH ? 'admin' : 'site';
}

export function navigate(path) {
  if (normalizePath(window.location.pathname) === normalizePath(path)) {
    return;
  }
  window.history.pushState({}, '', path);
  window.dispatchEvent(new Event(ROUTE_EVENT));
}

export function onRouteChange(handler) {
  window.addEventListener(ROUTE_EVENT, handler);
  window.addEventListener('popstate', handler);
  return () => {
    window.removeEventListener(ROUTE_EVENT, handler);
    window.removeEventListener('popstate', handler);
  };
}
